export default {
  API_URL: "https://cash.lowtax.com.br:8080/api",
  // API_URL: "http://localhost:8080/api",
};

// export const HOME_URL = "http://localhost:3000/#/";
export const HOME_URL = "https://cash.lowtax.com.br/#/";
